import styles from './ThemeCrossfade.module.css'

/**
 * Theme crossfade overlay — 300ms (150 + 150) opacity fade around
 * `map.setStyle` per UI-SPEC §Interaction & Motion (lines 487-496).
 *
 * The overlay colour matches the INCOMING theme's Dominant so the flash the
 * user sees is the next theme's surface colour — no inverse pulse.
 *
 * `prefers-reduced-motion: reduce` is handled by the CSS module: opacity
 * stays 0 with `transition: none`. Parent may still call `setStyle` — just
 * skip the active/inactive cycle.
 */
export interface ThemeCrossfadeProps {
  theme: 'day' | 'night'
  active: boolean
}

export function ThemeCrossfade({ theme, active }: ThemeCrossfadeProps) {
  const classes = [
    styles.overlay,
    theme === 'night' ? styles.night : styles.day,
    active ? styles.active : '',
  ]
    .filter(Boolean)
    .join(' ')
  return <div className={classes} aria-hidden="true" />
}
